export default "__VITE_ASSET__szqhvI0F__"